module.exports = __webpack_public_path__ + "static/media/great-people_2.ec399cd6.jpg";